export enum DisplayNameControlKeys {
  LEGAL_NAME = 'legal-name',
  PREFERRED_NAME = 'preferred-name',
}

export type DisplayNamePerson = { firstName: string; lastName: string; preferredName?: string };
export type DisplayNameOptions = { alwaysUseLegalName?: boolean };

export interface ResolvedDisplayName {
  firstName: string;
  lastName: string;
  fullName: string;
  preferredName?: string;
  isPreferred: boolean;
}
